import { render } from "./OidoGrid.vue?vue&type=template&id=22542498&scoped=true"
import script from "./OidoGrid.vue?vue&type=script&lang=js"
export * from "./OidoGrid.vue?vue&type=script&lang=js"

import "./OidoGrid.vue?vue&type=style&index=0&id=22542498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22542498"]])

export default __exports__